import angular from 'angular';
import dialogTemplate from './welcome-splash.html';
export var WelcomeSplashComponent = {
    template: "",
    controller: /** @class */ (function () {
        function WelcomeSplashComponent($mdDialog, WelcomeSplashService, UserService, $sce) {
            'ngInject';
            this.$mdDialog = $mdDialog;
            this.$sce = $sce;
            this.UserService = UserService;
            this.WelcomeSplashService = WelcomeSplashService;
        }
        WelcomeSplashComponent.prototype.$onInit = function () {
            this.welcomeSplashContent = '';
            this.getUser();
        };
        WelcomeSplashComponent.prototype.getUser = function () {
            var _this = this;
            this.UserService.get(true).then(function (response) {
                if (response.data.response) {
                    _this.getWelcomeSplashContent();
                }
            });
        };
        WelcomeSplashComponent.prototype.getWelcomeSplashContent = function () {
            var _this = this;
            this.WelcomeSplashService.getWelcomeSplashContent()
                .then(function (data) {
                if (data && data.detail && !_this.WelcomeSplashService.hasBeenSeen) {
                    _this.welcomeSplashContent = _this.$sce.trustAsHtml(data.detail);
                    _this.showSplash();
                }
            });
        };
        WelcomeSplashComponent.prototype.showSplash = function () {
            this.WelcomeSplashService.hasBeenSeen = true;
            this.$mdDialog.show({
                parent: angular.element(document.body),
                template: dialogTemplate,
                clickOutsideToClose: true,
                locals: {
                    welcomeSplashContent: this.welcomeSplashContent
                },
                controller: /** @class */ (function () {
                    function DialogController($mdDialog, welcomeSplashContent, WelcomeSplashService) {
                        'ngInject';
                        this.$mdDialog = $mdDialog;
                        this.welcomeSplashContent = welcomeSplashContent;
                        this.WelcomeSplashService = WelcomeSplashService;
                    }
                    DialogController.prototype.closeDialog = function () {
                        this.dontShowAgain();
                        this.$mdDialog.hide();
                    };
                    DialogController.prototype.dontShowAgain = function () {
                        this.WelcomeSplashService.dontShowAgain();
                    };
                    DialogController.prototype.onNoThanksClick = function () {
                        this.dontShowAgain();
                        this.closeDialog();
                    };
                    return DialogController;
                }()),
                controllerAs: '$ctrl'
            });
        };
        return WelcomeSplashComponent;
    }())
};
//# sourceMappingURL=welcome-splash.component.js.map